import React from 'react';

//components
import TopBar from './Topbar';

const Header = () => {
  return (
    <header>
      <TopBar />
    </header>
  );
};

export default Header;
